import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { CVLocalizationService } from '../services/cv-localization.service';

@Directive({
    selector: '[cvLocalizedPlaceholder]'
})
export class CvLocalizedPlaceholderDirective implements AfterViewInit {
    @Input() langSection: string;
    @Input() langKey: string;

    constructor(
        private service: CVLocalizationService,
        private element: ElementRef<HTMLInputElement>,
    ) {
    }

    ngAfterViewInit() {
        this.loadText();
    }

    async loadText() {
        const currText = this.element.nativeElement.placeholder;
        const text = await this.service.GetLocalText(this.langSection, this.langKey, currText);
        this.element.nativeElement.placeholder = text;
    }
}
